/**
 * Grail27 — sticky add-to-cart bar (product pages only; markup rendered by section).
 * Submits through the main PDP product-form so cart drawer behavior matches the primary ATC button.
 */
(function () {
  function findMainAddForm() {
    return (
      document.getElementById('GrailProductBuyCustom') ||
      document.querySelector('product-info form[data-type="add-to-cart-form"]') ||
      document.querySelector('.product-form form[data-type="add-to-cart-form"]')
    );
  }

  function resetStickyLoading(stickySubmitBtn) {
    if (!stickySubmitBtn) return;
    stickySubmitBtn.classList.remove('is-loading');
    stickySubmitBtn.removeAttribute('aria-busy');
  }

  function setStickyLoading(stickySubmitBtn) {
    if (!stickySubmitBtn) return;
    stickySubmitBtn.classList.add('is-loading');
    stickySubmitBtn.setAttribute('aria-busy', 'true');
  }

  function bindCartReset(stickySubmitBtn) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    function maybeReset(event) {
      if (!event || event.source !== 'product-form') return;
      resetStickyLoading(stickySubmitBtn);
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, maybeReset);
    subscribe(PUB_SUB_EVENTS.cartError, maybeReset);
  }

  function init() {
    var stickyBar = document.getElementById('grail-sticky-bar');
    var mainAddToCartBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    if (!stickyBar) return;

    if (mainAddToCartBtn) {
      var stickyShown = false;
      var rafId = null;

      function syncStickyFromMainAtc() {
        rafId = null;
        var rect = mainAddToCartBtn.getBoundingClientRect();

        if (rect.bottom <= 0) {
          stickyShown = true;
        } else if (rect.top >= 0) {
          stickyShown = false;
        }

        if (stickyShown) {
          stickyBar.classList.add('grail-sticky-visible');
        } else {
          stickyBar.classList.remove('grail-sticky-visible');
        }
      }

      function scheduleSync() {
        if (rafId != null) return;
        rafId = requestAnimationFrame(syncStickyFromMainAtc);
      }

      window.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('resize', scheduleSync);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleSync);
        window.visualViewport.addEventListener('scroll', scheduleSync);
      }
      scheduleSync();
    }

    var siteFooter = document.querySelector('footer, .footer, [id*="shopify-section-footer"]');
    if (siteFooter) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            stickyBar.classList.add('grail-hidden-by-footer');
          } else {
            stickyBar.classList.remove('grail-hidden-by-footer');
          }
        },
        { threshold: 0.05 }
      );
      footerObserver.observe(siteFooter);
    }

    var qtyInput = document.getElementById('sticky-qty-input');
    var plusBtn = document.querySelector('#grail-sticky-bar .qty-btn.plus');
    var minusBtn = document.querySelector('#grail-sticky-bar .qty-btn.minus');
    if (qtyInput && plusBtn && minusBtn) {
      plusBtn.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
      minusBtn.addEventListener('click', function () {
        if (parseInt(qtyInput.value, 10) > 1) qtyInput.value = parseInt(qtyInput.value, 10) - 1;
      });
    }

    var stickySubmitBtn = document.getElementById('grail-sticky-submit');
    if (stickySubmitBtn) {
      resetStickyLoading(stickySubmitBtn);
      bindCartReset(stickySubmitBtn);

      stickySubmitBtn.addEventListener('click', function () {
        var mainForm = findMainAddForm();
        if (!mainForm) return;

        var mainQty = mainForm.querySelector('[name="quantity"]');
        if (mainQty && qtyInput) {
          mainQty.value = qtyInput.value;
        }

        var mainSubmitBtn = mainForm.querySelector('[type="submit"][name="add"]');
        if (!mainSubmitBtn || mainSubmitBtn.hasAttribute('disabled')) return;

        setStickyLoading(stickySubmitBtn);
        mainSubmitBtn.click();

        window.setTimeout(function () {
          resetStickyLoading(stickySubmitBtn);
        }, 2500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
